import logo from '../images/powered_by_google_on_white.png';
import { importLibrary } from '@googlemaps/js-api-loader';
import { useEffect, useRef, useState } from 'react';

interface GooglePlacesProps {
    addressId: string;
    addressLabel: string;
    placeholder: string;
    className: string;
    useLargeLabel: boolean;
    afterValid(address: addressDetails): void;
}

//interface for storing results of address from google
interface addressDetails {
    fullAddress: string;
    street_number: string;
    route: string;
    locality: string;
    administrative_area_level_1: string;
    country: string;
    postal_code: string;
    latitude: number;
    longitude: number;
    placeId: string;
};

const GooglePlacesDropdown = (props: GooglePlacesProps) => {
    const inputRef = useRef<HTMLInputElement | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const { PlaceAutocompleteElement } = await importLibrary("places");

        try {
            if (!inputRef.current) return;

            // Bind the Autocomplete widget to the input element field
            const autocompleteInstance = new PlaceAutocompleteElement(
                {
                    includedRegionCodes: ["au"],
                }
            );

            autocompleteInstance.placeholder = props.placeholder;
            autocompleteInstance.style.width = "450px";

            // Add listener to handle option selections
            autocompleteInstance.addEventListener("gmp-select", handlePlaceSelect);

            if (inputRef.current) {
                inputRef.current.innerHTML = "";
                inputRef.current.appendChild(autocompleteInstance);
            }

            // Clean up event listener on component unmount
            return () => {
                autocompleteInstance.removeEventListener('gmp-select', handlePlaceSelect);
            };
        } catch (e) {
            console.error("Failed to load Google Maps Places Library", e);
            setError("Failed to load address autocomplete.");
        }
    }

    const resetAddress = () => {
        var addressFound: addressDetails = {
            fullAddress: "",
            street_number: "",
            route: "",
            locality: "",
            administrative_area_level_1: "",
            country: "",
            postal_code: "",
            latitude: 0,
            longitude: 0,
            placeId: ""
        };

        return addressFound;
    }

    const handlePlaceSelect = async (event: Event) => {
        const placeEvent = event as google.maps.places.PlacePredictionSelectEvent;
        //const autocompleteElement = event.currentTarget as google.maps.places.PlaceAutocompleteElement;

        var addressFound = resetAddress();

        const place = placeEvent.placePrediction.toPlace();
        await place.fetchFields({ fields: ['addressComponents', 'location', 'formattedAddress', 'id'] });

        if (place.addressComponents) {
            //var googleAddress = place.address_components;
            var address: any = addressFound;
            for (var i = 0; i < place.addressComponents.length; i++) {
                var addressType = place.addressComponents[i].types[0];
                if (addressType === "administrative_area_level_1") {
                    //state needs to be the short text as database is 5 characters
                    var value = place.addressComponents[i].shortText;
                    address[addressType] = value;
                } else {
                    var value = place.addressComponents[i].longText;
                    address[addressType] = value;
                }
            }

            if (place.location && place.location) {
                address["latitude"] = place.location.lat();
                address["longitude"] = place.location.lng();
            }
            address["placeId"] = place.id;
            address["fullAddress"] = place.formattedAddress;

            props.afterValid(address);
        } else {
            
            console.warn("No geometry details available for the selected destination.");
        }
    }

    return (
        <div>
            <label className={props.className} htmlFor="siteAddr">
                <span className={"label" + (props.useLargeLabel ? " label-large" : "")}>{props.addressLabel}</span>
                <div ref={inputRef} />
            </label>
            <img className={props.useLargeLabel ? "marginLeftLabelLarge" : "marginLeftLabel"} src={logo}></img>
            {error && <p style={{ color: "red", fontSize: "14px" }}>{error}</p>}
        </div>
    );
};

export default GooglePlacesDropdown;
